import { useCallback, useState } from 'react';
import { DirectCampaignUI } from '../../../../data-layer/direct/types';
import { ContentPromotionPostsValue } from '../../../../ui/business/ContentPromotionPosts/types';
import { usePostCollection } from '../../../post/usePostCollection';
import { useCurrentUser } from '../../../users/useCurrentUser';
import { POSTS_LIMIT } from '../constants';
import { makePostsFilters } from '../utils';

function getPostsSettings(company?: DirectCampaignUI) {
    const { feedSettings } = company || {};
    let postsValue = ContentPromotionPostsValue.ALL;

    if (feedSettings?.posts.length) {
        postsValue = ContentPromotionPostsValue.CHOICE;
    } else if (feedSettings?.freshnessDays && feedSettings?.freshnessDays > 0) {
        postsValue = ContentPromotionPostsValue.NEW;
    }

    return {
        postsValue,
        disabledPosts: feedSettings?.posts ?? [],
    };
}

export const usePromotionPosts = (company?: DirectCampaignUI) => {
    const currentUser = useCurrentUser();
    const posts = usePostCollection({
        namespace: 'promotion',
        filters: {
            businessId: currentUser?.profile?.publicId,
            amount: POSTS_LIMIT,
            ...makePostsFilters(),
        },
    });
    const postsSettings = getPostsSettings(company);

    const [postsValue, setPostsValue] = useState<ContentPromotionPostsValue | undefined>(
        postsSettings.postsValue,
    );

    const [disabledPosts, setDisabledPosts] = useState<string[]>(postsSettings.disabledPosts);
    const [visiblePostsDialog, setVisiblePostsDialog] = useState(false);
    const onPostsDialogClose = useCallback(
        () => setVisiblePostsDialog(false),
        [setVisiblePostsDialog],
    );
    const onPostsDialogSave = useCallback(
        (value: string[]) => {
            setDisabledPosts(value);
            setVisiblePostsDialog(false);
        },
        [setDisabledPosts, setVisiblePostsDialog],
    );

    const onPostsFieldChange = useCallback(
        (value?: ContentPromotionPostsValue) => {
            setPostsValue(value);

            if (value === ContentPromotionPostsValue.CHOICE) {
                setVisiblePostsDialog(true);
            } else {
                setDisabledPosts([]);
            }
        },
        [setVisiblePostsDialog, setPostsValue],
    );

    return {
        posts,
        postsValue,
        disabledPosts,
        visiblePostsDialog,
        onPostsDialogClose,
        onPostsDialogSave,
        onPostsFieldChange,
    };
};
